import { getRoundName } from './utils/tournamentUtils.js';
import { useTournamentState } from './TournamentContext.jsx';
import './ProgressIndicator.css';

/**
 * ProgressIndicator - Display current round and match progress
 * @param {Object} props
 * @param {number} props.currentMatchIndex - Current match index (0-based)
 * @param {number} props.totalMatches - Total number of matches in round
 * @param {string} props.language - Language code ('ko' or 'en')
 */
export default function ProgressIndicator({
  currentMatchIndex,
  totalMatches,
  language = 'ko',
}) {
  // Context에서 전체 state 접근 가능
  const state = useTournamentState();

  const currentMatch = currentMatchIndex + 1;
  const progressPercentage = (currentMatch / totalMatches) * 100;

  // Calculate round size from total matches (e.g., 8 matches = 16 participants)
  const roundSize = totalMatches * 2;
  const displayRoundName = getRoundName(roundSize, language);

  const progressLabel = language === 'ko'
    ? `${displayRoundName} 진행률: ${currentMatch}/${totalMatches}`
    : `${displayRoundName} progress: ${currentMatch}/${totalMatches}`;

  return (
    <div className="progress-indicator">
      <div className="progress-indicator__header">
        <h2 className="progress-indicator__round">{displayRoundName}</h2>
        <span className="progress-indicator__counter">
          {currentMatch} / {totalMatches}
        </span>
      </div>
      <div className="progress-indicator__bar-wrapper">
        <div
          className="progress-indicator__bar"
          style={{ width: `${progressPercentage}%`, background: state.themeColor }}
          role="progressbar"
          aria-valuenow={currentMatch}
          aria-valuemin="0"
          aria-valuemax={totalMatches}
          aria-label={progressLabel}
        />
      </div>
    </div>
  );
}